import {SvgFunction} from "@web-libs/ui/svgs/types";
import {withColor} from "@web-libs/ui/svgs/fill/with-color";

const _ErrorIcon:SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
    >
        <g clipPath="url(#a)">
            <path
                fill={props.fill}
                d="m31.121 12.64-4.668-8a6.688 6.688 0 0 0-5.757-3.307h-9.428A6.693 6.693 0 0 0 5.509 4.64l-4.668 8a6.681 6.681 0 0 0 0 6.719l4.668 8a6.688 6.688 0 0 0 5.758 3.306h9.428a6.693 6.693 0 0 0 5.758-3.306l4.667-8a6.681 6.681 0 0 0 .001-6.72Zm-2.305 5.375-4.665 8a4.015 4.015 0 0 1-3.456 1.984h-9.428a4.013 4.013 0 0 1-3.455-1.984l-4.667-8a4.005 4.005 0 0 1 0-4.031l4.666-8A4.015 4.015 0 0 1 11.267 4h9.428c1.416 0 2.741.76 3.454 1.984l4.667 8a4.005 4.005 0 0 1 0 4.03Zm-7.873-5.074L17.885 16l3.058 3.057a1.332 1.332 0 1 1-1.886 1.885L16 17.884l-3.057 3.057a1.33 1.33 0 0 1-1.886 0 1.332 1.332 0 0 1 0-1.885l3.058-3.057-3.058-3.058a1.332 1.332 0 1 1 1.886-1.885L16 14.113l3.057-3.057a1.332 1.332 0 1 1 1.886 1.885Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill={props.fill} d="M0 0h32v32H0z" />
            </clipPath>
        </defs>
    </svg>
)

const ErrorIcon = withColor(_ErrorIcon)
export default ErrorIcon
